<template>
	<div>
		<div class="filter-tag-row">
			<ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/>
			<!-- <span class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">Элементов: {{this.masObjects_total}}</span> -->
		</div>		
		<div class="col-md-12" v-show="bShowFilter">
			<ReFilter :masAllFilterParams="masAllFilterParams" 
			v-model="objGetParams" 
			v-on:filterapply="OnFilterApply"
			name="gkexclude"/>
		</div>

		<card>
			<el-table ref="multipleTable" 
				:data="ApiData"
				v-loading.fullscreen.lock="$GVO.fullscreenLoading"
				element-loading-text="Загрузка данных..."
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)"	
			>
				<el-table-column
					width="80"
					label="Ind"
					type="index"
				></el-table-column>			
				<el-table-column
					min-width="55"
					sortable
					label="Застройщик"
					property="dev_name"
				></el-table-column>			
				<el-table-column
					min-width="55"
					sortable
					label="Комплекс"
					property="gk_name"
				></el-table-column>			
				<el-table-column
					min-width="55"
					sortable
					label="Работаем"
					property="public"
				>
					<template v-slot="scope">
						<base-switch :key="scope.row.public"
							v-model="scope.row.public"
							type="primary"
							on-text="ДА"
							off-text="Нет"
							@change="setPrivate(scope.row)"
						></base-switch>
					</template>
				</el-table-column>
				<el-table-column
					min-width="55"
					sortable
					label="Выгружаем"
					property="export_exclude"
				>
					<template v-slot="scope">
						<base-switch :key="scope.row.export_exclude"
							v-model="scope.row.export_exclude"
							type="primary"
							on-text="ДА"
							off-text="Нет"
							@change="setExport(scope.row)"
						></base-switch>
					</template>
				</el-table-column>						
				<el-table-column
					min-width="55"
					sortable
					label="Приоритет"
					property="priority"
				>
					<template v-slot="scope">
						<base-switch :key="scope.row.priority"
							v-model="scope.row.priority"
							type="primary"
							on-text="ДА"
							off-text="Нет"
							@change="setPriority(scope.row)"
						></base-switch>
					</template>
				</el-table-column>						
			</el-table>
		</card>
		<Pagination :class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
			:type="'info'" 
			:total="parseInt(masObjects_total)" 
			:perPage="parseInt(count2page)"
			:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
			:pClick="pClick">
		</Pagination>	

	</div>
</template>
<script>
import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn } from 'element-ui';
import { BaseSwitch } from 'src/components/index';
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
import Pagination from 'src/our_components/RePagination';

export default {
	name: 'gk_exclude-page',
	components: {
		BaseSwitch,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		ReFilterBtn,
		ReFilter,
		Pagination,
	},
	data() {
		return {
			ApiData: [],
			bShowFilter: false,
			masAllFilterParams: this.currentFilterConfig(),
			masObjects_total: 0,
			count2page: 10,
			fullscreenLoading: false,
			objGetParams: {},
		};
	},
	methods: {
		getApiData(){
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				filter = this.objGetParams;
			}
			this.$GVO.ApiCall('GetGKExcludeList',{obj:'DEV',flt:{...filter}}) // 'GetMyDevExtraData',{obj:'DEV' ,flt:{}}
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;//.map(v=>((v.private=v.public=='0'),v));
					}
					if(objApi.total!=undefined) {this.masObjects_total=objApi.total;}
				}else {
					this.ApiData = [];
					this.masObjects_total=0;
				}
			}).catch(errorObjApi => {this.ApiData = []; this.masObjects_total=0; console.error(errorObjApi);});
		},
		setPrivate(row){
			//row.private=!row.private;
			this.$GVO.ApiCall('SetGKExcludeList',{obj:'DEV',flt:{},iData:{PK:row.PK,public:row.public}})
				.then(objApi=>{
					if(objApi.success === true && objApi.data){
						// выставить комплексу признак посел сохранения в базе
						row.public=objApi.data.public;
						//me.ApiData.some(d=>(d.PK==PK)?((d.private=objApi.data.private),console.log(d,objApi.data),true):false)
					}					
				})
		},
		setExport(row){
			this.$GVO.ApiCall('SetGKExportList',{obj:'DEV',flt:{},iData:{PK:row.PK,export_exclude:row.export_exclude}})
				.then(objApi=>{
					if(objApi.success === true && objApi.data){
						// выставить комплексу признак после сохранения в базе
						row.export_exclude=objApi.data.export_exclude;
					}					
				})
		},
		setPriority(row){
			this.$GVO.ApiCall('SetGKPriority',{obj:'DEV',flt:{},iData:{PK:row.PK,priority:row.priority}})
				.then(objApi=>{
					if(objApi.success === true && objApi.data){
						// выставить комплексу признак после сохранения в базе
						row.priority=objApi.data.priority;
					}					
				})
		},
		currentFilterConfig(){
			this.$GVO.ApiCall('DEV.GET_FILTER',{})
			.then((objApi) => {
				//console.log(objApi);
				if(objApi.success){
					this.masAllFilterParams = objApi.config;
					eventEmitter.$emit('OnFilterConfigLoad', this.masAllFilterParams);
				}
			})
			.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		OnFilterApply(data){
			// console.log('OnFilterApply',data);
			//console.log('OnFilterApply',this.objGetParams);
			if(typeof data != 'undefined' && typeof this.objGetParams['p'] != 'undefined'){
				delete this.objGetParams['p'];
			}

			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
				}
			}
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);
			this.getApiData();
		},
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			this.OnFilterApply();
		},
	},
	mounted() {
		this.objGetParams = this.$GVO.GetAllGet();
		this.getApiData();
	}
};
</script>
<style>
</style>
